import { api } from '../services/api';
import type { GameModule } from '../types/game';

export async function validateModuleAnswer(module: GameModule, answer: string): Promise<boolean> {
  if (module.validation?.mode === 'server') return (await api.validateAnswer(module.id, answer)).correct;
  const accepted = module.validation?.acceptedAnswers ?? [];
  const candidate = answer.trim();
  return accepted.some((value) => module.validation?.caseSensitive
    ? value.trim() === candidate
    : value.trim().localeCompare(candidate, undefined, { sensitivity: 'accent' }) === 0);
}

